import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import {
  Typography, Button, Grid,
} from '@material-ui/core';
import Header from './Header/Header';
// import Footer from './Footer/Footer';
import KpiSection from './KpiSection/KpiSection';
import BarDonutSection from './BarDonutSection/BarDonutSection';
import WaffleSection from './WaffleSection/WaffleSection';
import BubbleSection from './BubbleSection/BubbleSection';
import SwarmSection from './SwarmSection/SwarmSection';
import PieSection from './PieSection/PieSection';

const useStyles = makeStyles((theme) => ({
  app: {
    backgroundColor: theme.palette.background.main,
    padding: '40px 0 0 0',
  },
  contentWrapper: {
    padding: '0 30px',
    [theme.breakpoints.down('xs')]: {
      padding: 0,
    },
  },
  intro: {
    fontSize: '1.125em',
  },
  introText: {
    maxWidth: 700,
  },
  cta: {
    backgroundColor: '#BE7999',
    padding: '10px 15px',
    borderRadius: 3,
    width: '100%',
    maxWidth: 270,
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#955e78',
    },
  },
  ctaText: {
    display: 'block',
    fontSize: '0.7em',
    paddingTop: 10,
    maxWidth: 270,
  },
  gridItmBubble: {
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '0 !important',
    },
  },
  gridItmTopJournalists: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: '0 !important',
    },
    '@media (min-width: 1100px)': {
      paddingLeft: '102px !important',
    },
  },
  footnotecontainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 50,
    '@media(max-width: 684px)': {
      justifyContent: 'center',
    },
  },
  footnote: {
    position: 'absolute',
    color: '#5C5C5C',
    fontStyle: 'italic',
    fontSize: 12,
    '@media(max-width: 684px)': {
      position: 'relative',
      textAlign: 'center',
    },
  },
}));

const App = () => {
  const classes = useStyles();
  return (
    <div className={classes.app}>
      <Header />
      <Container maxWidth="lg">

        <Grid container spacing={4} className={classes.intro}>
          <Grid item xs={12} sm={8}>
            <Typography variant="body1" className={classes.introText}>
              The Canadian Association of Journalists’ first annual diversity survey includes data from 3,873 journalists working in 209 newsrooms nationwide. It is Canada’s largest survey of the race and gender of those who work in media. Data analysis and interactives were produced by Pennsylvania-based firm Qlik.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Box>
              <Button variant="contained" color="primary" className={classes.cta} target="_blank" href="https://caj.ca/wp-content/uploads/diversity_survey_report-2.pdf">
                Final Report
              </Button>
              <Typography variant="body1" className={classes.ctaText}>An 18-page report detailing national results, methodology, data limitations, and a full list of who participated.</Typography>
            </Box>
          </Grid>
        </Grid>

        <Box className={classes.contentWrapper}>
          <KpiSection
            header="Newsroom Demographics"
            text="Here’s the national breakdown of who works in Canadian newsrooms. You can toggle by race, gender and job role to see different results."
          />
          <WaffleSection />
          <SwarmSection
            header="Individual newsroom results vs. Audience"
            text="Newsrooms with over five full-time employees are compared with the audiences they serve. Hover over a bubble to see the breakdown for a newsroom or select “My Newsroom” to search for a media outlet."
          />
          <Grid container spacing={9}>
            <Grid item sm={12} md={6} className={classes.gridItmBubble}>
              <BubbleSection
                header="Newsroom Leadership Vs. Staff"
                text="We compared the percentage of supervisors who identified as visible minority or Indigenous to the percentage of visible minority and/or Indigenous staff. The same comparison was done for women supervisors and staff. Newsrooms along the reference line have an equal proportion. You can toggle between race and gender or search for a specific newsroom. Hover over a bubble to see detailed results for a newsroom."
              />
            </Grid>
            <Grid item sm={12} md={6} className={classes.gridItmTopJournalists}>
              <PieSection
                header="Top 3 Journalists"
                text="We asked newsrooms to indicate if they had a visible minority or Indigenous journalist in a top-three editorial position (e.g. editor-in-chief; executive producer; deputy editor)."
              />
            </Grid>
          </Grid>

          <BarDonutSection
            header="Who is Getting Better Jobs?"
            text="You can toggle by race and gender to see which kinds of journalists at a national level hold more senior and stable jobs. You can search for a specific newsroom’s results or select multiple to see averages."
          />
        </Box>
      </Container>
      <Container maxWidth="lg">
        <div className={classes.footnotecontainer}>
          <Typography variant="body1" className={classes.footnote}>*Newsrooms shown are those with 6 full-time staff or more except for the Waterloo Region Record.</Typography>
        </div>
      </Container>
      {/* <Footer /> */}
    </div>
  );
};

App.propTypes = {};

export default App;
